import { updateItems } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            吃瓜快讯
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            实时追踪51黑料吃瓜入口与黑料吃瓜在线最新动态
          </p>
        </div>
        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300"></div>
          <div className="space-y-5">
            {updateItems.map((item, idx) => (
              <div key={idx} className="relative flex gap-4 pl-10">
                <div className="absolute left-0 w-[38px] h-[38px] flex items-center justify-center">
                  <div className="w-2.5 h-2.5 rounded-full bg-primary-500 ring-4 ring-background-50"></div>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                    <span className="px-1.5 py-0.5 bg-accent-100 text-accent-700 text-xs rounded whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">{item.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}